import React, { useEffect, useState } from "react";
import { api, formatApiErrorDetail } from "@/lib/api";
import { DeliveryHeader } from "@/components/beta03/DeliveryHeader";
import { ComponentsTable } from "@/components/beta03/ComponentsTable";
import { CompositionTable } from "@/components/beta03/CompositionTable";
import { OwnerInputs } from "@/components/beta03/OwnerInputs";
import { DiffSection } from "@/components/beta03/DiffSection";
import { Evidence } from "@/components/beta03/Evidence";
import { NextSteps } from "@/components/beta03/NextSteps";

/** Consegna BETA-03 (Owner/Admin): dati letti dall'esecuzione finale dei gate + evidenze E2E; sole letture. */
export default function Beta03Delivery() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => {
    api.get("/beta03/delivery").then(({ data }) => setD(data)).catch((e) => setErr(formatApiErrorDetail(e.response?.data?.detail, { status: e.response?.status, network: !e.response })));
  }, []);
  if (err) return <div className="p-4 text-[11px] border border-risk-300 bg-risk-50 m-4 rounded-md" data-testid="b03-error"><b>Consegna BETA-03</b> — non disponibile: {err}</div>;
  if (!d) return <div className="p-4 text-[11px]" data-testid="b03-loading">Consegna BETA-03 — lettura dell'esecuzione dei gate…</div>;
  const rc = d.real_case || {};
  return (
    <div className="p-4 space-y-3" data-testid="beta03-delivery-page">
      <h1 className="font-display font-bold text-xl">Consegna BETA-03</h1>
      <DeliveryHeader d={d} />
      <OwnerInputs oi={rc.owner_inputs} summary={rc.summary} />
      <ComponentsTable rows={rc.per_component || []} summary={rc.summary} />
      <CompositionTable comp={rc.pricing_composition} />
      <DiffSection d={d.e2e_ui?.fixture_draft_vs_real} />
      <Evidence d={d} />
      <NextSteps appUrl={rc.app_url} />
    </div>
  );
}
